<div class="shop-card">
  <a class="shop-card-link" [routerLink]="['/shop', shop.slug]">
    <div class="shop-banner">
      <img [src]="bannerImage" alt="" loading="lazy" decoding="async" width="320" height="140" />

      <div class="shop-badges">
        <span class="badge badge-featured" *ngIf="shop.is_featured">
          <i class="fas fa-crown"></i> Featured
        </span>
        <span class="badge badge-popular" *ngIf="featureFlags.popularBadge && isPopular">
          <i class="fas fa-fire"></i> Popular
        </span>
      </div>

      <span class="status-pill" [class.open]="isOpen">
        <i class="fas fa-circle"></i> {{ isOpen ? 'Open' : 'Closed' }}
      </span>

      <div class="shop-logo-wrapper">
        <img class="shop-logo" [src]="logoImage" alt="" loading="lazy" decoding="async" width="48" height="48" />
      </div>
    </div>

    <div class="shop-body">
      <div class="shop-title-row">
        <h3 class="shop-name">{{ shop.name }}</h3>
        <span class="shop-rating" *ngIf="shop.rating">
          <i class="fas fa-star"></i>{{ shop.rating | number:'1.1-1' }}
        </span>
      </div>

      <div class="shop-category-list" *ngIf="categoryNames.length">
        <span class="shop-category-pill" *ngFor="let cat of categoryNames">{{ cat }}</span>
      </div>
      <p class="shop-category muted" *ngIf="!categoryNames.length">&nbsp;</p>

      <div class="shop-meta-row">
        <span class="meta-item" *ngIf="deliveryTimeLabel"><i class="fas fa-clock" aria-hidden="true"></i> {{ deliveryTimeLabel }}</span>
        <ng-container *ngIf="shop.distance != null">
          <span class="dot" *ngIf="deliveryTimeLabel" aria-hidden="true">&bull;</span>
          <span class="meta-item">{{ shop.distance | number:'1.1-1' }} km</span>
        </ng-container>
        <ng-container *ngIf="shop.review_count">
          <span class="dot">&bull;</span>
          <span class="meta-item">{{ shop.review_count }} reviews</span>
        </ng-container>
      </div>

      <div class="shop-address" *ngIf="shortAddress">
        <i class="fas fa-map-marker-alt"></i>
        <span>{{ shortAddress }}</span>
      </div>
    </div>
  </a>

  <div class="shop-actions">
    <button type="button" class="btn-quick-view" (click)="onQuickView($event)">
      <i class="fas fa-eye"></i> Quick View
    </button>
    <a class="btn-visit-shop" [routerLink]="['/shop', shop.slug]">
      Visit Shop <i class="fas fa-arrow-right"></i>
    </a>
  </div>
</div>
